// extracted by mini-css-extract-plugin
module.exports = {"Flag":"FlagImage_Flag__pVVOm"};